/**
 * PHARMAKON — Toast context object.
 *
 * Split out of ToastContext.jsx so that file exports only the provider
 * component: a module exporting a component alongside a context object cannot
 * be hot-swapped by React Fast Refresh (react-refresh/only-export-components),
 * and ~50 modules import this context.
 */
import { createContext } from "react";

export const ToastContext = createContext();
